import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";


export interface FermerRecherchePictoProps extends pictoProps {
}

export interface FermerRecherchePictoState extends pictoState {
}

export class FermerRecherchePicto extends Picto<FermerRecherchePictoProps,FermerRecherchePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.fermerRecherchePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FermerRecherchePicto);
